import React, { useState } from "react";

import { Button, Modal, TextField } from "@king-ict/eupisi-ui/components";
import {
  Typography,
  RadioGroup,
  RadioButton,
  UnauthorizedPage,
} from "@king-ict/eupisi-ui/components";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useTypedSelector } from "../../app";
import { useAuthorization } from "../../hooks";
import { UserAuthData } from "../../models";

export const UserRoleAuthorization = () => {
  const [selectedAuthDataId, setSelectedAuthDataId] = useState<number>();

  const [searchFilter, setSearchFilter] = useState<string>("");

  const [filterData, setFilterData] = useState<UserAuthData[]>();

  const { t } = useTranslation();

  const authData = useTypedSelector((s) => s.application.userAuthData);
  const { isInitialized, isAuthorized, updateUserAuthData } = useAuthorization(
    true
  );

  const authorizationData = (filterData && filterData.length > 0)  ? filterData : authData;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAuthDataId(+e.target.value);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchFilter(e.target.value);
    if (e.target.value === null) {
      setFilterData(undefined);
    }
    else {
      setFilterData(filterByValue(authData, e.target.value));
    }    
    setSelectedAuthDataId(undefined);
  };

  function filterByValue(array: UserAuthData[] | undefined, searchFilter: string) {     
      return array?.filter((data) =>  
      (`${data.institutionName}, ${data.townName}`).toLowerCase().indexOf(searchFilter.trimStart().toLowerCase()) !== -1);   
  };

  const handleSelect = () => {
    const authDataItem = authData?.find((a) => a.id === selectedAuthDataId);
    if (authDataItem != null) {
      updateUserAuthData(authDataItem);
    }
  };

  const isDisabled = (selectedAuthDataId === undefined);

  if (isAuthorized || !isInitialized) {
    return null;
  }

  if (authData?.length === 0) {
    return (
      <UnauthorizedPage
        partial
        title={t("authorization.modalNoAuthDataMessage")}
      />
    );
  }

  return (
    <Modal
      open={!isAuthorized}
      onClose={() => {}}
      showCloseMark= {false}
    >
      <Typography variant="mediumBold">
        {t("authorization.modalSelectText")}
      </Typography>
      <Row>
        <Col xs={12}>
          <TextField 
          value={searchFilter} onChange={handleSearch}
          label={t("authorization.modalSearchFilter")}/>
        </Col>
      </Row>
      <RadioGroup name={"roleSelect"} title="" onChange={handleChange}>
        {authorizationData?.map((a) => (
          <RadioButton
            ariaLabel={`${a.roleName} (${
              a.institutionName ? a.institutionName : a.enrollmentGroupName
            },  ${a.townName})`}
            key={a.id}
            label={`${a.roleName} (${
              a.institutionName ? a.institutionName : a.enrollmentGroupName
            }, ${a.townName})`}
            value={a.id}
            checked={a.id === selectedAuthDataId}
          />
        ))}
      </RadioGroup>
      <Container>
        <Row>    
          <Col xs={12} className="text-center">
            <Button color="primary" onClick={handleSelect} disabled={isDisabled}>
              {t("common.select")}
            </Button>
          </Col>
        </Row>        
      </Container>     
    </Modal>
  );
};
